/* PRIMO EUROPA — Limpieza y jerarquía exclusiva de páginas legales */
(() => {
  const legalPaths = new Set([
    '/sobre-nosotros/',
    '/aviso-legal-impressum/',
    '/politica-de-privacidad/',
    '/politica-de-cookies/'
  ]);

  const requestedPath = document.body.getAttribute('data-primo-legal-path') || window.location.pathname;
  const path = requestedPath.endsWith('/') ? requestedPath : `${requestedPath}/`;
  if (!legalPaths.has(path)) return;

  document.body.classList.add('primo-legal-clean-template');

  const legacySelectors = [
    '#gh-navigation',
    '#primo-header-flags',
    '#primo-main-interface',
    '#primo-trust-badge',
    '#primo-testimonials',
    '#primo-leadmagnet',
    '#primo-legalbar',
    '.gh-footer',
    '.gh-container'
  ];

  const arrangeLegalPage = () => {
    legacySelectors.forEach((selector) => {
      document.querySelectorAll(selector).forEach((node) => node.remove());
    });

    const backBar = document.querySelector('#primo-back-bar');
    const articleHeader = document.querySelector('.gh-article-header');
    if (backBar && articleHeader && articleHeader.firstElementChild !== backBar) {
      articleHeader.insertBefore(backBar, articleHeader.firstElementChild);
    }
  };

  // Ghost inserta la inyección de pie después de source.js. Se repite la
  // limpieza para retirar esos bloques y conservar el regreso encima del título.
  arrangeLegalPage();
  [0, 250, 900, 1800].forEach((delay) => window.setTimeout(arrangeLegalPage, delay));
  new MutationObserver(arrangeLegalPage).observe(document.body, {childList: true, subtree: true});
})();
